import { selectBuildingsInfoByTypeId } from "../../../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../../../utils/utilBuildings";
import { utilFunction } from "../../../../../utils/utilFunction";
import { createPathSelectBuildingMaxLevel } from "../../../path/createPathSelectBuildingMaxLevel";
export var pathSelectBuildingMaxLevelExceptProductionDoneState = function (action, state$, deps) {
    return createPathSelectBuildingMaxLevel(function () {
        var state = state$.value;
        var availableBuildingsOfType = selectBuildingsInfoByTypeId(state, action.taskType.buildingId);
        return availableBuildingsOfType.filter(utilFunction.negate(utilBuildings.hasFinishedProduction));
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-building/paths/pathSelectBuildingMaxLevelExceptProductionDoneState.ts
// module id = 2380
// module chunks = 3